import { Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable({ providedIn: "root" })
export class SendTrackingFacade {
	constructor(
		private readonly segmentService: SegmentService,
		private readonly rudderstackService: RudderstackService
	) {}

	public trackSendNetworkListViewed(): void {
		this.segmentService.track({ name: "Crypto Send Network Selection Screen Viewed" });
		this.rudderstackService.track({ name: "Crypto Send Network Selection Screen Viewed" });
	}

	public trackSendFlowStarted(): void {
		this.segmentService.track({ name: "Send Flow Started" });
		this.rudderstackService.track({ name: "Send Flow Started" });
	}

	public trackSendNetworkListClicked(network: string): void {
		this.segmentService.track({
			name: "Crypto Send Network List Network Clicked",
			properties: { network: network }
		});
		this.rudderstackService.track({
			name: "Crypto Send Network List Network Clicked",
			properties: { network: network }
		});
	}

	public trackAssetClickedInChooseAssetModal(assetSymbol: string): void {
		this.segmentService.track({
			name: "Crypto Send Asset List Item Clicked",
			properties: { asset: assetSymbol }
		});
		this.rudderstackService.track({
			name: "Crypto Send Asset List Item Clicked",
			properties: { asset: assetSymbol }
		});
	}

	public trackChooseAssetModalViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Asset List Screen Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Asset List Screen Viewed"
		});
	}

	public trackWarningViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Warning Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Warning Viewed"
		});
	}

	public trackWarningButtonUnderstandClicked(): void {
		this.segmentService.track({
			name: "Crypto Send Warning I Understand Button Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Warning I Understand Button Clicked"
		});
	}

	public trackWarningLinkFraudsClicked(): void {
		this.segmentService.track({
			name: "Crypto Send Warning Online Scams And Other Fraud Link Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Warning Online Scams And Other Fraud Link Clicked"
		});
	}

	public trackRecipientScreenViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Choose Recipient Screen Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Choose Recipient Screen Viewed"
		});
	}

	public trackRecipientChosen(): void {
		this.segmentService.track({
			name: "Crypto Send Choose Recipient Screen Next Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Choose Recipient Screen Next Clicked"
		});
	}

	public trackAmountScreenViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Amount Screen Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Amount Screen Viewed"
		});
	}

	public trackAmountScreenCurrencyTypeClicked(): void {
		this.segmentService.track({
			name: "Crypto Send Amount Screen Currency Type Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Amount Screen Currency Type Clicked"
		});
	}

	public trackAmountScreenNextClicked(): void {
		this.segmentService.track({
			name: "Crypto Send Amount Screen Next Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Amount Screen Next Clicked"
		});
	}

	public trackSummaryScreenViewed(assetSymbol: string): void {
		this.segmentService.track({
			name: "Crypto Send Summary Screen Viewed",
			properties: { asset: assetSymbol }
		});
		this.rudderstackService.track({
			name: "Crypto Send Summary Screen Viewed",
			properties: { asset: assetSymbol }
		});
	}

	public trackSummaryTransferButtonClicked(): void {
		this.segmentService.track({
			name: "Crypto Send Summary Transfer Clicked"
		});
		this.rudderstackService.track({
			name: "Crypto Send Summary Transfer Clicked"
		});
	}

	public trackSummaryTooltipViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Summary Empty Optional Field Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Summary Empty Optional Field Viewed"
		});
	}

	public trackEmailConfirmationScreenViewed(): void {
		this.segmentService.track({
			name: "Crypto Send Email Confirmation Sent Screen Viewed"
		});
		this.rudderstackService.track({
			name: "Crypto Send Email Confirmation Sent Screen Viewed"
		});
	}

	public trackSuccessScreenViewed(assetSymbol: string, network: string): void {
		this.segmentService.track({
			name: "Crypto Send Successful Screen Viewed",
			properties: { asset: assetSymbol, network: network }
		});
		this.rudderstackService.track({
			name: "Crypto Send Successful Screen Viewed",
			properties: { asset: assetSymbol, network: network }
		});
	}
}
